import update from "immutability-helper";

import {
  OPENS_STARTED,
  OPENS_FAILURE,
  OPENS_SUCCESS,
  OPENS_ABORTED,
} from "@js/actions/studio/stats/studio_opens_overview_by_privacy.js";

export default (state = {}, action) => {
  switch (action.type) {
  case OPENS_STARTED:
    return update(state, { $merge: {
      loading: true,
      loaded: false,
      error_message: null,
      summary: null,
    } });
  case OPENS_FAILURE:
    return update(state, { $merge: {
      loading: false,
      loaded: false,
      error_message: action.error_message,
      summary: null,
    } });
  case OPENS_SUCCESS:
    return update(state, { $merge: {
      loading: false,
      loaded: true,
      error_message: null,
      summary: action.summary,
    } });
  case OPENS_ABORTED:
    return update(state, { $merge: {
      loading: false,
      loaded: false,
      error_message: null,
      summary: null,
    } });
  default:
    return state;
  }
};
